import { ReadonlyList } from '../../misc/readonly-list/implementation';
import { MakeFactory } from '../../classes/class-helpers/factory';
import { BaseClass } from '../../classes/class-helpers/base-class';
import { IsObservable } from '../observable/constructor';
import { LinkObservableAndObserver, UnLinkObservableAndObserver } from '../observable/functions';
import { OBSERVER_PRIVATE } from './privates';
import { ConstructObserver } from './constructor';
export function ObserverGetActivated(instance) {
    return instance[OBSERVER_PRIVATE].activated;
}
export function ObserverGetObservables(instance) {
    const privates = instance[OBSERVER_PRIVATE];
    if (privates.readOnlyObservables === void 0) {
        privates.readOnlyObservables = new ReadonlyList(privates.observables);
    }
    return privates.readOnlyObservables;
}
export function ObserverGetObserving(instance) {
    return instance[OBSERVER_PRIVATE].observables.length > 0;
}
export function ObserverEmit(instance, value, observable) {
    const privates = instance[OBSERVER_PRIVATE];
    if (privates.activated) {
        privates.onEmit(value, observable);
    }
}
export function ObserverActivate(instance) {
    const privates = instance[OBSERVER_PRIVATE];
    if (!privates.activated) {
        privates.activated = true;
        const observables = privates.observables;
        for (let i = 0, l = observables.length; i < l; i++) {
            LinkObservableAndObserver(observables[i], instance);
        }
    }
}
export function ObserverDeactivate(instance) {
    const privates = instance[OBSERVER_PRIVATE];
    if (privates.activated) {
        privates.activated = false;
        const observables = privates.observables;
        for (let i = 0, l = observables.length; i < l; i++) {
            UnLinkObservableAndObserver(observables[i], instance);
        }
    }
}
export function ObserverObserve(instance, observables) {
    const privates = instance[OBSERVER_PRIVATE];
    for (let i = 0, l = observables.length; i < l; i++) {
        const observable = observables[i];
        if (IsObservable(observable)) {
            if (privates.observables.includes(observable)) {
                throw new Error(`Already observing this Observable`);
            }
            else {
                privates.observables.push(observable);
                if (privates.activated) {
                    LinkObservableAndObserver(observables[i], instance);
                }
            }
        }
        else {
            throw new TypeError(`Expected Observable as argument #${i + 1} of Observer.observe.`);
        }
    }
}
export function ObserverUnobserve(instance, observables) {
    for (let i = 0, l = observables.length; i < l; i++) {
        if (IsObservable(observables[i])) {
            ObserverUnobserveOne(instance, observables[i]);
        }
        else {
            throw new TypeError(`Expected Observable as argument #${i + 1} of Observer.unobserve.`);
        }
    }
}
export function ObserverUnobserveOne(instance, observable) {
    const privates = instance[OBSERVER_PRIVATE];
    const index = privates.observables.indexOf(observable);
    if (index === -1) {
        throw new Error(`Not observing this Observable`);
    }
    else {
        privates.observables.splice(index, 1);
        if (privates.activated) {
            UnLinkObservableAndObserver(observable, instance);
        }
    }
}
export function ObserverUnobserveAll(instance) {
    const privates = instance[OBSERVER_PRIVATE];
    for (let i = 0, l = privates.observables.length; i < l; i++) {
        if (privates.activated) {
            UnLinkObservableAndObserver(privates.observables[i], instance);
        }
    }
    privates.observables.length = 0;
}
function PureObserverFactory(superClass) {
    return class Observer extends superClass {
        constructor(...args) {
            const [onEmit] = args[0];
            super(...args.slice(1));
            ConstructObserver(this, onEmit);
        }
        get activated() {
            return ObserverGetActivated(this);
        }
        get observables() {
            return ObserverGetObservables(this);
        }
        get observing() {
            return ObserverGetObserving(this);
        }
        emit(value, observable) {
            ObserverEmit(this, value, observable);
        }
        activate() {
            ObserverActivate(this);
            return this;
        }
        deactivate() {
            ObserverDeactivate(this);
            return this;
        }
        observe(...observables) {
            ObserverObserve(this, observables);
            return this;
        }
        unobserve(...observables) {
            ObserverUnobserve(this, observables);
            return this;
        }
        disconnect() {
            ObserverUnobserveAll(this);
            return this;
        }
    };
}
export let Observer;
export function ObserverFactory(superClass) {
    return MakeFactory(PureObserverFactory, [], superClass, {
        name: 'Observer',
        instanceOf: Observer,
    });
}
Observer = class Observer extends ObserverFactory(BaseClass) {
    constructor(onEmit) {
        super([onEmit]);
    }
};
//# sourceMappingURL=implementation.js.map